import { generateClientErrorMessage } from "../utils/generateClientErrorMessage"
import { emailApi } from "../config/emailSenderApi"

export const sendContactEmail = async (contactData) => {
    try {
        const res = await emailApi.post('/sendUniversalLPEmail', { 
            ...contactData, 
            subject: 'Solicitação de contato — Intermodal 2026',
            lpName: 'Landing Page - Intermodal 2026',
            recipientEmail: "contato@ghlogistica.com.br",
            colors: {
            primaryColor:     '#093390',
            secondaryColor:   '#002972',
            accentColor:      '#FF6700',
            backgroundColor:  'rgb(218, 218, 218)',
            textColor:        '#f5f7f6',
            },
        })

        if (res.status !== 200) {
            return { success: false, message: generateClientErrorMessage(res) }
        }

        return { success: true, message: res.data.message }

    } catch (error) {
        console.error(error)
        return { success: false, message: generateClientErrorMessage(error) }
    }
}